import { render } from "./MerceDataTable.vue?vue&type=template&id=65a288ef&scoped=true"
import script from "./MerceDataTable.vue?vue&type=script&lang=js"
export * from "./MerceDataTable.vue?vue&type=script&lang=js"

import "./MerceDataTable.vue?vue&type=style&index=0&id=65a288ef&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a288ef"]])

export default __exports__